import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import fundo from "../../../styles/fundo.svg";
import "./style.css";

const Geral = styled.div`
  width: 98%;
  box-shadow: 0px 0px 2px #ccc;
  padding: 5px;
  background-color: #ffffff;

`;
const Table = styled.table`
  width: 99%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 5px auto;

`;

export const TdButton = styled.td`
  font-size: 14px;
  font-weight: bold;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;
  text-decoration: none;
  border: none;
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    color: black;
    background-color: #f5f5f5;
  }


`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;


`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 

`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;


`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;


`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  transition: transform 0.1s;
  background-color: transparent;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
display: flex;
align-items: center;

  
  span{
    padding: 0px  10px;
  }
`;

const DivMedia = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;

const Media = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 30px;
  background-color: #fff;
  margin-bottom: 10px;
  box-shadow: 0px 0px 2px #ccc;
  span {
    font-size: 16px;
  }

  h1 {
    font-size: 32px;
  }
`;

const ButtonExport = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
  margin-left: 10px;
  &:hover {
    background-image:url(${fundo});
  }

  
`;

const Grid = ({ exata_CS, treinamentosEXATA }) => {


  const groupedDepartments = exata_CS.reduce((acc, item) => {
    const { cod_departamento, departamento, status } = item;

    if (!acc[cod_departamento]) {
      acc[cod_departamento] = {
        cod_departamento,
        departamento,
        statusCount: { I: 0, P: 0, F: 0 }, // Inicia as contagens de status
      };
    }

    // Contagem de status
    if (status === 'I') acc[cod_departamento].statusCount.I++;
    if (status === 'P') acc[cod_departamento].statusCount.P++;
    if (status === 'F') acc[cod_departamento].statusCount.F++;

    return acc;
  }, {});


  // Converte o objeto agrupado para um array para renderizar
  const currentItems = Object.values(groupedDepartments);


  const [searchTermSetor, setSearchTermSetor] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(currentItems);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleSearchSetor = (term) => {
      setIsLoading(true);
      try {
        const filtered = currentItems.filter((user) => {
          const departamento = user.departamento ? user.departamento.toLowerCase() : '';
          return departamento.includes(term.toLowerCase());
        });

        // Verifica se os resultados filtrados são diferentes antes de atualizar o estado
        if (JSON.stringify(filtered) !== JSON.stringify(filteredUsers)) {
          setFilteredUsers(filtered);
        }
      } catch (error) {
        console.error("Erro ao pesquisar:", error);
      }
      setIsLoading(false);
    };

    handleSearchSetor(searchTermSetor);
  }, [searchTermSetor, currentItems, filteredUsers]); // Inclui filteredUsers como dependência







  //--------------------------------------------------------------------------------------------------------------//

  const [totalTreinamento, setTotalTreinamento] = useState('');


  useEffect(() => {
    if (treinamentosEXATA) {
      const totalTreinamento = treinamentosEXATA.length;
      setTotalTreinamento(totalTreinamento.toLocaleString('pt-BR'));
    }

  }, [treinamentosEXATA]);



  const contarStatus = (exata_CS) => {
    const contagem = exata_CS.reduce((acc, user) => {
      const status = user.status;
      if (!acc[status]) {
        acc[status] = 0;
      }
      acc[status] += 1;
      return acc;
    }, {});

    // Formata os valores de contagem com .toLocaleString('pt-BR')
    const contagemFormatada = Object.fromEntries(
      Object.entries(contagem).map(([key, value]) => [key, value.toLocaleString('pt-BR')])
    );

    return contagemFormatada;
  };


  const contagemStatus = contarStatus(exata_CS);



  //--------------------------------------------------------------------------------------------------------------//

  const exportToExcel = () => {
    const dadosParaExportar = filteredUsers.map((dept) => ({
      "Código": dept.cod_departamento,
      "Departamento": dept.departamento,
      "Presente": dept.statusCount.P,
      "Faltante": dept.statusCount.F,
      "Imprevisto": dept.statusCount.I,
    }));

    // Criar uma planilha
    const ws = XLSX.utils.json_to_sheet(dadosParaExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Departamentos");

    // Criar um arquivo Excel e baixar
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "relatorio_departamentos.xlsx");
  };

  //--------------------------------------------------------------------------------------------------------------//
  // Estados de Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Itens por página

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  // Aplicação da Paginação (agora sobre os dados ordenados)
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems2 = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Funções de Paginação
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  //--------------------------------------------------------------------------------------------------------------//

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };


  return (

    <Geral>
      <DivMedia>
        <Media>
          <span>Total de Treinamentos:</span>
          <h1>{totalTreinamento}</h1>
        </Media>
        <Media>
          <span>Total de Presentes:</span>
          <h1>{contagemStatus.P}</h1>
        </Media>
        <Media>
          <span>Total de Imprevistos:</span>
          <h1>{contagemStatus.I}</h1>
        </Media>
        <Media>
          <span>Total de Faltantes:</span>
          <h1>{contagemStatus.F}</h1>
        </Media>

      </DivMedia>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar setor"
          value={searchTermSetor}
          onChange={(e) => setSearchTermSetor(e.target.value)}
        />

        <Div>
          <div>
            <Button onClick={handlePrevPage} disabled={currentPage === 1}><ImArrowLeft size={20} /></Button>
            <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}> <ImArrowRight size={20} /></Button>
          </div>
        </Div>

        <Div>
          <p>Exportar: </p>
          <ButtonExport onClick={exportToExcel}>Excel</ButtonExport>
        </Div>
      </Td3>
      <Table >

        <Thead>
          <Tr>
            <Th onClick={() => onColumnClick("cod_departamento")} className={getSortClass("cod_departamento")}>
              Cód. {getSortIcon("cod_departamento")}
            </Th>
            <Th onClick={() => onColumnClick("departamento")} className={getSortClass("departamento")}>
              Departamento {getSortIcon("departamento")}
            </Th>
            <Th onClick={() => onColumnClick("statusCount.P")} className={getSortClass("statusCount.P")}>
              Presente {getSortIcon("statusCount.P")}
            </Th>
            <Th onClick={() => onColumnClick("statusCount.F")} className={getSortClass("statusCount.F")}>
              Faltante {getSortIcon("statusCount.F")}
            </Th>
            <Th onClick={() => onColumnClick("statusCount.I")} className={getSortClass("statusCount.I")}>
              Imprevisto {getSortIcon("statusCount.I")}
            </Th>

          </Tr>
        </Thead>
        <Tbody>
          {currentItems2.map((dept, i) => (
            <Tr key={i}>
              <Td>{dept.cod_departamento}</Td>
              <Td>{dept.departamento}</Td>
              <Td>{dept.statusCount.P}</Td>
              <Td>{dept.statusCount.F}</Td>
              <Td>{dept.statusCount.I}</Td>
            </Tr>
          ))}

        </Tbody>

      </Table>

    </Geral>
  );
};


export default Grid;
